import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ITelemetryLogger } from '@cian/telemetry/shared';
import { IBrowserMicrofrontend } from '@cian/mf-registry/browser/microfrontend/types';

export enum EPlacingLayoutType {
  packagesWithoutBet = 'packagesWithoutBet',
  packages = 'packages',
  services = 'services',
}
export interface IPublishTermsContainerProps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
  telemetry: ITelemetryLogger;
  microfrontend: IBrowserMicrofrontend;
}
